 import { CABLES, MCB, RCD } from "./Malzeme";
import { mainFeeder_03_a, mainFeeder_01 } from "../utils/defaultFeederTypes";
 
export function findCableByCurrent(current, sectionCount, kapType, minKesit, tolerans, type) {

    const toleransedCurrent = current * tolerans / 100 + current

    const iletken = CABLES.find((obj) => obj.airCurCap >= toleransedCurrent && obj.section >= minKesit && obj.sectionCount === sectionCount && obj.type === type)
    return iletken
}
export function findAOSForCable(currentCable, I0, phaseCount, minI0, type, Ith, tolerans) {
    const toleransedCurrent = currentCable * tolerans / 100 + currentCable
    const kesici = MCB.find((obj) =>
        obj.current <= toleransedCurrent &&
        obj.current >= I0 &&
        obj.current >= minI0 &&
        obj.shortCircuitCurCap === Ith &&
        obj.polar === phaseCount &&
        obj.curve === type

    )
    return kesici
}
export function findKAKRByCurrent(current, phaseCount, sensitivity, type) {

    const kesici = RCD.find((obj) => obj.current === current && obj.polar === phaseCount && obj.sensitivity === sensitivity)
    return kesici
}

export function calculatePower(data) {
    let result
    let demandPower, current, demandFactor ,phaseCount
    const {lightPower, socketPower } = data;
    if (data || data.installedPower >10000) { // 10kW Tekfaz sınır değer
        //10kw dan büyük güçlerde sistem 3 faz olacak.
        phaseCount = 3
    } else {    
        phaseCount = data.phaseCount  ; // Varsayılan olarak 3 faz
         
    }
    switch (data.purposeOfUse) {
        case "Mesken":
            demandFactor = "60-40%"
            if (data.type === "fuseBox" || data.type === "panel" || data.type === "supply" || data.type === "meterPanel" || data.type === "dist_panel") {

                if (data.installedPower > 8000) {
                    demandPower = 4800 + (data.installedPower - 8000) * 0.4
                } else {
                    demandPower = data.installedPower * 0.6
                }
            }
            break;
        case "İşYeri":
            demandFactor = "100-50%"
            if (data.type === "fuseBox" || data.type === "meterPanel" || data.type === "supply" || data.type === "dist_panel") {
               // demandPower = data.installedPower * 0.75
                if( socketPower > 10000) {
                    demandPower = 10000 + ( socketPower - 10000) * 0.5+lightPower
                }   else{
                    demandPower = data.installedPower  +lightPower
                }
            }
            break;

        case "Müşterek":
            demandFactor = "100%"
            if (data.type === "fuseBox" || data.type === "meterPanel" || data.type === "supply" || data.type === "dist_panel") {
                demandPower = data.installedPower
            }
            break;
            
        case "Asansör":
            demandFactor = "55%"
            if (data.type === "fuseBox" || data.type === "meterPanel" || data.type === "supply" || data.type === "dist_panel") {
                demandPower = data.installedPower * 0.55
            }
            break;

    }
    current = phaseCount === 3 ? demandPower / 526 : demandPower / 220
    result = {
        installedPower: data.installedPower,
        demandPower,
        demandFactor,
        purposeOfUse: data.purposeOfUse,
        current,
        phaseCount:phaseCount,
        subscribeType: data.subscribeType || "Mesken",
    } 

    return result
}

export function updateFeeder(data, chain) {
    const { current, feederType, cable } = data;

    const defaultFeeder =
        feederType === "mf-03-a" ? mainFeeder_03_a :
            feederType === "mf-01" ? mainFeeder_01 :
                null;

    if (defaultFeeder) {
        // Update the feeder with the new data
        defaultFeeder.current = current;
        defaultFeeder.cable = cable;
    }
}